/**
 * 矢羽根・束ねの時間区間（ISO 文字列）の共通計算。
 * 合成判断（resolve-group-declaration）・ドロップ予測（simulate-group-drop）・
 * 楽観更新（optimistic-board-patch）で同じ意味論を使う必要があるためここに 1 本置く。
 */

/** 半開区間 [start, end) での重なり判定（BE の isTimeOverlap と同じ。境界の接触は重なりとしない） */
export const overlaps = (
  aStartAt: string,
  aEndAt: string,
  bStartAt: string,
  bEndAt: string
) =>
  Date.parse(aStartAt) < Date.parse(bEndAt) &&
  Date.parse(aEndAt) > Date.parse(bStartAt)

/** 明細群の表示範囲（親矢羽根の外枠にあたる min startAt 〜 max endAt） */
export const envelopeOf = (
  details: { startAt: string; endAt: string }[]
): { startAt: string; endAt: string } | null => {
  const first = details[0]
  if (!first) return null
  return details.reduce(
    (envelope, detail) => ({
      startAt:
        Date.parse(detail.startAt) < Date.parse(envelope.startAt)
          ? detail.startAt
          : envelope.startAt,
      endAt:
        Date.parse(detail.endAt) > Date.parse(envelope.endAt)
          ? detail.endAt
          : envelope.endAt
    }),
    { startAt: first.startAt, endAt: first.endAt }
  )
}

/**
 * 開始時刻の昇順（同時刻は id 昇順）。板は時刻を左から右へ読むため、明細の並びと
 * 「先頭の候補を採る」判断を全経路で同じ規則に揃える
 */
export const compareByStartAtThenId = (
  a: { id: number; startAt: string },
  b: { id: number; startAt: string }
) => Date.parse(a.startAt) - Date.parse(b.startAt) || a.id - b.id

/** {@link compareByStartAtThenId} で最も先頭の 1 件。並べ替えずに走査するだけ */
export const earliestByStartAt = <T extends { id: number; startAt: string }>(
  items: T[]
): T | undefined =>
  items.reduce<T | undefined>(
    (earliest, item) =>
      earliest == null || compareByStartAtThenId(item, earliest) < 0
        ? item
        : earliest,
    undefined
  )
